import ConfiguratorStore from './ConfiguratorStore'
import FeatureFlagStore from './FeatureFlagStore'
import WizardStore from './WizardStore'
import AdminStore from './AdminStore'

const wizardStore = new WizardStore(location.href)
const confStore = new ConfiguratorStore()
const featureStore = new FeatureFlagStore()
const adminStore = new AdminStore()

export interface StoreProps {
  wizardStore?: WizardStore
  confStore?: ConfiguratorStore
  featureStore?: FeatureFlagStore
  adminStore?: AdminStore
}

export const stores: StoreProps = {
  wizardStore,
  confStore,
  featureStore,
  adminStore
}



// WEBPACK FOOTER //
// ./src/stores/index.ts